// extracted by mini-css-extract-plugin
module.exports = {"collapsible-wrapper":"collapsible_collapsible-wrapper__LD9Qr","cta-wrapper":"collapsible_cta-wrapper__0P4o7"};